import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { AppRouterOutletDirective } from '@app/modules/core/directives/app-router-outlet';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule
  ],
  exports: [
    HeaderModule,
    FooterModule,
    AppRouterOutletDirective
  ],
  declarations: [
    AppRouterOutletDirective
  ],
  providers: [
    DomManipulateService
  ]
})
export class CoreModule {
}
